import React from "react";
import theme from "theme";
import { Theme, Image, Box, Section, Text } from "@quarkly/widgets";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";

import image_projarticles_image10 from "../assets/images_projarticles/20240715_104956.jpg";

export default () => {
  return (
    <Theme theme={theme}>
      <GlobalQuarklyPageStyles pageUrl={"index"} />
      <Components.CombinedHelmetNHeader />
      <Section
        padding="60px 0 40px 0"
        quarkly-title="Section_DataDashboard_Title"
      >
        <Box
          md-width="100%"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          width="100%"
          display="flex"
          align-self="auto"
          flex="1 1 0%"
          align-items="center"
          flex-direction="column"
          justify-content="center"
          flex-wrap="no-wrap"
        >
          <Text
            margin="0px 0px 40px 0px"
            color="--light"
            font="--headline2"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-margin="0px 0px 16px 0px"
          >
            'Our Data Dashboard' page
          </Text>
          <Text
            color="--light"
            font="--base"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            margin="0px 0px 0px 0px"
            text-align="left"
          >
            Our data dashboard is a place where viewers can freely explore all
            the data our of projects, using a timeseries data historian.
          </Text>
        </Box>
      </Section>
      <Section
        padding="60px 0 60px 0"
        md-padding="30px 0 30px 0"
        quarkly-title="Section_DD_Content"
      >
        <Override
          slot="SectionContent"
          flex-direction="row"
          md-flex-wrap="wrap"
        />
        <Box
          empty-min-width="64px"
          padding="0px 0px 0px 0px"
          md-padding="0px 0px 0px 0px"
          md-width="100%"
          width="50%"
          lg-padding="0px 28px 0px 0px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
        >
          <Text
            font="--headline2"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-font="normal 500 28px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            margin="0px 0px 12px 0px"
            color="--green"
          >
            Data-licious
          </Text>
          <Text
            color="--light"
            font="--base"
            text-align="left"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            md-margin="0px 0px 16px 0px"
            margin="0px 0px 0px 0px"
          >
            Use the data historian to view historical csv data from projects
            like the greenhouse and PCM thermal storage.
          </Text>
        </Box>
        <Box
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          width="50%"
          md-width="100%"
          empty-min-width="64px"
          empty-min-height="64px"
        >
          <Image
            src={image_projarticles_image10}
            width="90%"
            max-height="350px"
            object-fit="cover"
            lg-min-height="300px"
            md-max-height="277px"
            md-min-height="16px"
            height="100%"
            overflow="hidden"
            srcSet={`${image_projarticles_image10} 500w, ${image_projarticles_image10} 800w, ${image_projarticles_image10} 1080w, ${image_projarticles_image10} 1600w, ${image_projarticles_image10} 2000w, ${image_projarticles_image10} 2600w, ${image_projarticles_image10} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
        </Box>
      </Section>
      <Section
        padding="60px 0 60px 0"
        md-padding="30px 0 30px 0"
        quarkly-title="Section_DD_Content2"
      >
        <Override
          slot="SectionContent"
          flex-direction="row"
          md-flex-wrap="wrap"
        />
        <Box
          empty-min-width="64px"
          padding="0px 0px 0px 0px"
          md-padding="0px 0px 0px 0px"
          md-width="100%"
          width="50%"
          lg-padding="0px 28px 0px 0px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          margin="0px 0px 0px 0px"
        >
          <Text
            font="--headline2"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-font="normal 500 28px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            margin="0px 0px 12px 0px"
            color="--green"
          >
            Extra Info
          </Text>
          <Text
            color="--light"
            font="--base"
            text-align="left"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            md-margin="0px 0px 16px 0px"
            margin="0px 0px 0px 0px"
          >
            This can be an extra paragraph overflow of the above content.
          </Text>
        </Box>
      </Section>
      <Section
        padding="60px 0 60px 0"
        md-padding="30px 0 30px 0"
        quarkly-title="Section_DD_Content3_ExLink"
      >
        <Override
          slot="SectionContent"
          flex-direction="row"
          md-flex-wrap="wrap"
        />
        <Box
          empty-min-width="64px"
          padding="0px 0px 0px 0px"
          md-padding="0px 0px 0px 0px"
          md-width="100%"
          width="50%"
          lg-padding="0px 28px 0px 0px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          margin="0px 0px 0px 0px"
        >
          <Text
            font="--headline2"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-font="normal 500 28px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            margin="0px 0px 12px 0px"
            color="--green"
          >
            External Link to data dashboard or csv file(s)
          </Text>
          <Text
            color="--light"
            font="--base"
            text-align="left"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            md-margin="0px 0px 16px 0px"
            margin="0px 0px 0px 0px"
          >
            The dashboard might be too difficult to embed into this webpage, so
            we could link it to another simple website who's sole purpose is
            data dashboard. we could also link the csv data file(s) here.
          </Text>
        </Box>
      </Section>
      <Components.CustomFooter />
      <RawHtml>
        <style place={"endOfHead"} rawKey={"6166a2b829a0a1001e6ca5fb"}>
          {
            ":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"
          }
        </style>
      </RawHtml>
    </Theme>
  );
};
